import { ChangelogItemTypeEnum } from '../types/enums/ChangelogItemType.enum.ts';

export type ChangelogTypeStyle = {
  name: string;
  color: string;
  borderColor: string;
};

const TYPE_STYLES: Record<number, ChangelogTypeStyle> = {
  [ChangelogItemTypeEnum.FEATURE]: { name: 'Feature', color: '#4299e1', borderColor: '#4299e1' },
  [ChangelogItemTypeEnum.IMPROVEMENT]: { name: 'Improvement', color: '#48bb78', borderColor: '#48bb78' },
  [ChangelogItemTypeEnum.DATA]: { name: 'Data', color: '#4fd1c5', borderColor: '#4fd1c5' },
  [ChangelogItemTypeEnum.BUGFIX]: { name: 'Bugfix', color: '#e53e3e', borderColor: '#e53e3e' },
};

export const getChangelogTypeStyle = (typeId: number): ChangelogTypeStyle => TYPE_STYLES[typeId];
